<template>
        <div class="creneau">
            <h5 class="text-center">Sélectionner votre créneau</h5>
            <div v-if="Object.keys(free_times).length > 0" class="creneau-time-hours">
            <!-- <div class="creneau-time-hours"> -->
                <div v-for="(free_time, index) in free_times" :key="index" @click="select(index, free_time)" role="button">
                    <h5 class="text-center" :class="{
                        active : configs['MULTIPLE_RDV'] == 1 && !store.rdvToModify ? selected_freetimes[free_time.start] : (isActive === index), 
                            'free-timeslot-disabled': is_free_time_disabled(free_time),
                            'checked-blocked': !unselect_ordered(free_time)}"
                    >
                        {{ getTimeDisplay(free_time) }}
                    </h5>
                </div>
            </div>
            <div v-else class="creneau-vide">
                <svg width="42" height="45" viewBox="0 0 42 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M27.5995 25.7245L24.4531 28.875L27.6056 32.0255C28.0635 32.4834 28.3208 33.1044 28.3208 33.752C28.3208 34.3996 28.0635 35.0207 27.6056 35.4786C27.1477 35.9365 26.5266 36.1938 25.8791 36.1938C25.2315 36.1938 24.6104 35.9365 24.1525 35.4786L21 32.3281L17.8495 35.4806C17.3916 35.9385 16.7706 36.1958 16.123 36.1958C15.4754 36.1958 14.8543 35.9385 14.3964 35.4806C13.9385 35.0227 13.6812 34.4016 13.6812 33.7541C13.6812 33.1065 13.9385 32.4854 14.3964 32.0275L17.5469 28.875L14.4005 25.7245C14.1737 25.4978 13.9939 25.2286 13.8712 24.9324C13.7485 24.6361 13.6853 24.3186 13.6853 23.998C13.6853 23.6773 13.7485 23.3598 13.8712 23.0636C13.9939 22.7673 14.1737 22.4981 14.4005 22.2714C14.6272 22.0447 14.8964 21.8648 15.1926 21.7421C15.4889 21.6194 15.8064 21.5562 16.127 21.5562C16.4477 21.5562 16.7652 21.6194 17.0614 21.7421C17.3577 21.8648 17.6269 22.0447 17.8536 22.2714L21 25.4219L24.1505 22.2694C24.3772 22.0426 24.6464 21.8628 24.9426 21.7401C25.2389 21.6174 25.5564 21.5542 25.877 21.5542C26.1977 21.5542 26.5152 21.6174 26.8114 21.7401C27.1077 21.8628 27.3769 22.0426 27.6036 22.2694C27.8303 22.4961 28.0102 22.7653 28.1329 23.0615C28.2556 23.3578 28.3188 23.6753 28.3188 23.9959C28.3188 24.3166 28.2556 24.6341 28.1329 24.9303C28.0102 25.2266 27.8303 25.4958 27.6036 25.7225L27.5995 25.7245ZM41.3125 7.75V40.25C41.3125 41.3274 40.8845 42.3608 40.1226 43.1226C39.3608 43.8845 38.3274 44.3125 37.25 44.3125H4.75C3.67256 44.3125 2.63925 43.8845 1.87738 43.1226C1.11551 42.3608 0.6875 41.3274 0.6875 40.25V7.75C0.6875 6.67256 1.11551 5.63925 1.87738 4.87738C2.63925 4.11551 3.67256 3.6875 4.75 3.6875H8.8125V2.875C8.8125 2.22853 9.06931 1.60855 9.52643 1.15143C9.98355 0.694307 10.6035 0.4375 11.25 0.4375C11.8965 0.4375 12.5165 0.694307 12.9736 1.15143C13.4307 1.60855 13.6875 2.22853 13.6875 2.875V3.6875H28.3125V2.875C28.3125 2.22853 28.5693 1.60855 29.0264 1.15143C29.4835 0.694307 30.1035 0.4375 30.75 0.4375C31.3965 0.4375 32.0165 0.694307 32.4736 1.15143C32.9307 1.60855 33.1875 2.22853 33.1875 2.875V3.6875H37.25C38.3274 3.6875 39.3608 4.11551 40.1226 4.87738C40.8845 5.63925 41.3125 6.67256 41.3125 7.75ZM5.5625 8.5625V13.4375H36.4375V8.5625H33.1875C33.1875 9.20897 32.9307 9.82895 32.4736 10.2861C32.0165 10.7432 31.3965 11 30.75 11C30.1035 11 29.4835 10.7432 29.0264 10.2861C28.5693 9.82895 28.3125 9.20897 28.3125 8.5625H13.6875C13.6875 9.20897 13.4307 9.82895 12.9736 10.2861C12.5165 10.7432 11.8965 11 11.25 11C10.6035 11 9.98355 10.7432 9.52643 10.2861C9.06931 9.82895 8.8125 9.20897 8.8125 8.5625H5.5625ZM36.4375 39.4375V18.3125H5.5625V39.4375H36.4375Z" fill="#FBBC00"/>
                </svg>
                <h6>Aucun créneau disponible. </h6>                                   
            </div>
            
        </div>
</template>

<script>
    import moment from 'moment'
import { BookingStore } from '../Stores/BookingStore';
    
    export default {
        name: 'TimePicker',
        props: ['days', 'selected_day', 'free_times', 'configs', 'can_select_number', 'current_left_number_to_select', 'unselect'],
        emits: ['selected','unselected'],

        data() {
            return {
                store: BookingStore,
                isActive: null,
                // selectedIndex: null,
                selected_freetime: null,
                selected_freetimes: {}
            }
        },
        computed: {
            get_free_times(){
                return this.free_times ?? [];
            },
            is_multiple_rdv_enable(){

            }
        },
        methods: {
            toggleIsActive(index,freetime) {
                if (this.isActive === index) {
                    this.isActive = null;
                    this.select_freetime(null);
                }
                else {
                    this.isActive = index;
                    this.select_freetime(freetime);
                }
            },
            formatDateMoment(date, format) {
                return moment(date).locale('fr').format(format)
            },
            select_freetime(freetime){
                this.selected_freetime = freetime;
                this.$emit('selected',this.selected_freetime);
            },

            select_freetime_multiple(free_time, index=null){
                // Déselection
                let selected_number = this.can_select_number - this.current_left_number_to_select;
                if(this.selected_freetimes[free_time.start]){
                    // Si il y a un nombre divisible par le nombre imposé
                    if(this.configs['MULTIPLE_RDV_ORDER'] != 'NONE' && selected_number % parseInt(this.configs['SLOT_IMPOSITION_FROM']) == 0){
                        let keys = Object.keys(this.selected_freetimes).reverse();
                        let i = 0;
                        for (let j = 0; j < keys.length && i < parseInt(this.configs['SLOT_IMPOSITION_FROM']); j++) {
                            if(free_time.start == keys[j] || (free_time.start != keys[j] && i >= 1)){
                                this.selected_freetimes[keys[j]] = false;
                                let found_free_time = this.days[moment(keys[j]).format('YYYY-MM-DD')]?.free_times.find(f => f.start == keys[j]);
                                this.$emit('unselected',found_free_time);
                                i++;
                            }
                        }
                    }else{
                        this.selected_freetimes[free_time.start] = false;
                        this.$emit('unselected',free_time);
                    }
                // Sélection
                }else{
                    if(this.current_left_number_to_select >= this.configs['SLOT_IMPOSITION_FROM'] && this.configs['MULTIPLE_RDV_ORDER'] != 'NONE'){
                        // Sélection automatique des rdvs consécutifs cas ASC
                        if(this.configs['MULTIPLE_RDV_ORDER'] == "ASC"){
                            for (let i = index; i < index + parseInt(this.configs['SLOT_IMPOSITION_FROM']); i++) {
                                this.selected_freetimes[this.free_times[i].start] = true;
                                this.$emit(this.selected_freetimes[this.free_times[i].start] ? 'selected' : 'unselected',this.free_times[i]);
                            }
                        // Sélection automatique des rdvs consécutifs cas DESC
                        }else{
                            for (let i = index; i >= (this.free_times.length - parseInt(this.configs['SLOT_IMPOSITION_FROM']) + 1); i--) {
                                this.selected_freetimes[this.free_times[i].start] = true;
                                this.$emit(this.selected_freetimes[this.free_times[i].start] ? 'selected' : 'unselected',this.free_times[i]);
                            }
                        }
                    }else{
                        this.selected_freetimes[free_time.start] = true;
                        this.$emit(this.selected_freetimes[free_time.start] ? 'selected' : 'unselected',free_time);
                    }
                }
                // this.$emit(this.selected_freetimes[free_time.start] ? 'selected' : 'unselected',free_time);
            },
            
            select(index, free_time){
                // Si le créneau est désactivé arrêter l'event
                if(this.is_free_time_disabled(free_time) || !this.unselect_ordered(free_time)){
                    return;
                }
                // Si rendez-vous multiple actif
                if(this.configs['MULTIPLE_RDV'] == 1 && !this.store.rdvToModify){
                    this.select_freetime_multiple(free_time,index);
                }else{
                    this.toggleIsActive(index,free_time);
                } 
            },
        
            getTimeDisplay(free_time) {
                    if (this.configs['DISPLAY_FREETIME_TITLE_FO'] == 1 && free_time.title && free_time.title.length > 0) {
                        return free_time.title;
                    }
                    return this.formatDateMoment(free_time.start, 'HH:mm');
    
            },
            is_free_time_disabled(free_time){
                if(!this.ordered(free_time)){
                    return true;
                }
                if(!this.has_enough_freetimes()){
                    return true;
                }
                return false;
            },
            has_enough_freetimes(){
                if(this.configs['SLOT_IMPOSITION_FROM'] > this.current_left_number_to_select){
                    return true;
                }else if((this.free_times.length - this.current_day_selected_freetimes_keys().length) >= this.configs['SLOT_IMPOSITION_FROM']){
                    return true;
                }
                return false;
            },
            ordered(free_time){
                let is_ordered = true;
                // Déjà ordonné si multiple rdv désactivé ou il s'agit de la modification , ou quand le nombre de sélection imposé est selectionné
                if(this.configs['MULTIPLE_RDV'] == 0 || this.store.rdvToModify || this.selected_freetimes[free_time.start] || this.configs['SLOT_IMPOSITION_FROM'] > this.current_left_number_to_select){
                    return is_ordered;
                }
                let index = this.free_times.findIndex(f => f.start == free_time.start);
                switch (this.configs['MULTIPLE_RDV_ORDER']) {
                    case 'ASC':
                        // Si prémier créneau ou le précédent sélectionné donc est dans l'ordre de la sélection
                        if(index == 0 || this.selected_freetimes[this.free_times[index-1].start]){
                            is_ordered = true;
                        }else{
                            is_ordered = false;
                        }
                        break;

                    case 'DESC':
                        // Si dernier créneau ou le suivant sélectionné donc est dans l'ordre de la sélection
                        if(index == (this.free_times.length - 1) || this.selected_freetimes[this.free_times[index+1].start]){
                            is_ordered = true;
                        }else{
                            is_ordered = false;
                        }
                        break;
                    default:
                        is_ordered = true;
                        break;
                }
                    
                return is_ordered;
            },
            unselect_ordered(free_time){
                let is_ordered = true;
                // Déjà ordonné si multiple rdv désactivé ou il s'agit de la modification ou créneau déselectionné
                if(this.configs['MULTIPLE_RDV'] == 0 || this.configs['MULTIPLE_RDV_ORDER'] == 'NONE' || !this.selected_freetimes[free_time.start] || this.configs['SLOT_IMPOSITION_FROM'] > this.can_select_number){
                    return is_ordered;
                }
                
                // Trouver le créneau du dernier sélectionné                                        
                let start = null;
                for (const key of Object.keys(this.selected_freetimes).reverse()) {
                    if(this.selected_freetimes[key]){
                        start = key;
                        break;
                    }
                }
                // Vérifier si dernier créneau sélectionné correspond 
                if(start == null || start == free_time.start){
                    is_ordered = true;
                }else{
                    is_ordered = false
                }
                return is_ordered;
            },
            count_selected_freetimes(){
                return Object.keys(this.selected_freetimes).length;
            },
            current_day_selected_freetimes_keys(){
                return Object.keys(this.selected_freetimes).filter(key => key.includes(this.selected_day));
            },
            available_freetimes(){

            }          
        },
        updated(){
            
        },
        mounted(){
            
        },
        watch: {
            unselect(new_value, old_value) {
                this.select_freetime_multiple(new_value);
            },
          
            free_times() {
                this.isActive = null;
                this.selected_freetime = null;

                if(this.configs['MULTIPLE_RDV'] != 1 || this.store.rdvToModify) {
                    this.selected_freetimes = {};
                }
            }
        }
        
    }
</script>

<style scoped>
    .creneau h5 {
        text-align: center;
    }
    @media screen and (max-width: 992px) {
        .creneau{
            padding: 0rem 0;
        }
        .creneau h5 {
            margin-bottom: 0.75rem;
        }
    }
    
    .creneau-time-hours{
        max-height: 350px;
    }

    .free-timeslot-disabled{
        cursor: not-allowed;
        color: #07070796;
        border: 1px solid #07070796 !important;
    }
    
    .checked-blocked{
        cursor: not-allowed;
        opacity: 0.6;
    }
</style>